<template>
<div class="vliveGuideCover">
    <div class="guide-cover">
        <div class="upload cover-image">
            <div class="avatar-uploader" @click="openLocalGallery">
                <div class="el-upload el-upload--text">
                    <i class="el-icon-plus avatar-uploader-icon icon_upload" v-if="!liveInfoData.posterurl.furl"></i>
                    <img :src="liveInfoData.posterurl.furl" alt="" v-else class="avatar">
                </div>
            </div>
        </div>
        <div class="el-upload__tip">建议像素：750（宽）*1206（高），JPG、PNG格式，大小不超过5M。</div>
    </div>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_editGuideCover" :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
import {updateLivePost} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
export default {
    name: 'vliveGuideCover',
    props: ['liveInfoData'],
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            guideCover: {
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            cropperOption: {
                fixedNumber: [750, 1206], // 截图框的宽高比例
                enlarge: 5, // 图片根据截图框输出比例倍数
                autoCropWidth: 150, // 默认生成截图框宽度
                autoCropHeight: 241.2 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
        }
    },
    mounted() {},
    methods: {
        // 打开本地图片剪裁框
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        // 提交封面引导信息
        _editGuideCover (file) {
            this.timestamp = new Date().getTime()
            this.setLoading(true)
            updateLivePost({
                data: {
                    innerid: this.$route.query.id,
                    posterurl: formatFileInfo(file)
                },
                success: data => {
                    this.$message.success('保存成功！')
                    this.guideCover.coverPicture = file
                    console.log(this.guideCover)
                    
                    this.setVliveModelGuideCover(Object.assign({}, this.guideCover))
                    this.$emit('getLiveInfoData')
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelGuideCover',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.guideCover = Object.assign({}, this.vliveModel.guideCover)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.vliveGuideCover {
    .guide-cover{
        margin-top: 30px;
        .icon{
            margin-bottom: 20px;
        }
        .icon, .avatar-uploader{
            box-sizing: border-box;
            height: 400px;
            width: 250px;
        }
    }
}
</style>
